import React, {useState, useEffect}  from 'react';
import ContentEditable from 'react-contenteditable'
import { useSelector, useDispatch } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { getClone } from "../../../../utils";
import { v4 as uuidv4 } from "uuid";
import { setChosenImage } from "../../../../../actions";
import AddImage from "../helpers/addImage";
import t from "../../../../translate";
import ReactTooltip from 'react-tooltip';

// Import TinyMCE Core
import 'tinymce/tinymce';

// Import Theme, Icons, and Model
import 'tinymce/themes/silver'; // Default theme
import 'tinymce/icons/default'; // Default icons
//import 'tinymce/models/dom';    // DOM model

// Import Required Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';

const Tabs = (props) => {

  const [state, setState] = useState({
    items:[],
    active_item:0 /// deze wordt gebruikt bij zetten van de geuploade afbeelding
  });

  const url = useSelector(state => state.url);
  const medialibrary = useSelector(state => state.mediaLibrary);
  const dispatch = useDispatch();

  //////////////////////
  ///Save if chosen image uit bieb is not empty alleen bij overeenkomstige id
  if(medialibrary.chosen_image != "" && medialibrary.index == props.index)
  {
    /// empty chosen image status
    dispatch(
      setChosenImage(
        ''
      )
    );
    imageAction(medialibrary.chosen_image);
  }

  //////////////////////
  ///Get content
  useEffect(() => {

    if(props.items != "")
    {
      let newState = getClone(state)
      newState.items = props.items
      for(let i = 0 ; i < newState.items.length ; i ++)
      {
        if(newState.items[i].visible != false){
          newState.active_item = i;
        }
      }
      setState(newState);
    }
  }, []);

  //////////////////////
  ///Delete item
  function deleteItem(index) {
    ReactTooltip.hide()
    let clonedState = getClone(state);
    clonedState.items.splice(index, 1);
    let newActiveItemIndex = (clonedState.items.length - 1) >= 0 ? clonedState.items.length - 1:0
    toggleVisibility(newActiveItemIndex);
    saveChange(clonedState)
  }
  //////////////////////
  ///Add item
  function addItem(){
    let clonedState = getClone(state);
    for(let i = 0 ; i < clonedState.items.length ; i ++)
    {
      clonedState.items[i].visible = false;
    }
    clonedState.items.push({content:'', id:uuidv4(), content2:'', visible:true, image:''});
    clonedState.active_item = clonedState.items.length - 1

    saveChange(clonedState)

  }
  //////////////////////
  ///Toggle visibility item
  function toggleVisibility(index)
  {
    let clonedState = getClone(state);
    for(let i = 0 ; i < clonedState.items.length ; i ++)
    {
      clonedState.items[i].visible = false;
    }
    clonedState.items[index].visible = clonedState.items[index].visible == true ? false:true;
    clonedState.active_item = index
    saveChange(clonedState)
  }
  //////////////////////
  ///Update content tab
  function updateContent(index, value){
    let clonedState = getClone(state);
    clonedState.items[index].content = value
    saveChange(clonedState)
  }
  //////////////////////
  ///Update content tab content
  function updateContent2(index, value){
    let clonedState = getClone(state);
    clonedState.items[index].content2 = value
    saveChange(clonedState)
  }
  //////////////////////
  ///Swap position tab
  function swapItem(indexA, indexB){
     let clonedState = getClone(state);
     var a = clonedState.items[indexA];
     clonedState.items[indexA] = clonedState.items[indexB];
     clonedState.items[indexB] = a;
     saveChange(clonedState)
   }
   //////////////////////
   ///Set selected image
   //////////////////////
   function imageAction(){
     let clonedState = getClone(state);
     clonedState.items[state.active_item].image = url + "/uploads/intervention/" + medialibrary.chosen_image
     saveChange(clonedState)
   }
   //////////////////////
   ///Delete image
   //////////////////////
   function deleteImage(){
     let clonedState = getClone(state);
     clonedState.items[state.active_item].image = ''
     saveChange(clonedState)
   }
   ///Save
  function saveChange(clonedState){
    setState(clonedState)
    props.updatePart(props.index, 'items', clonedState.items)
  }

  //////////////////////
  ///Content
  return (
    <div className="special accordion">
      <div className="tabs">
        { state.items.map((item, index) =>
          <div key={index} className={"item " + (item.visible == true ? 'content_visible':'')}>
            <div onClick={() => toggleVisibility(index)} className="title">
              <ContentEditable
                html={item.content != "" ? item.content:""} // innerHTML of the editable div
                disabled={false}       // use true to disable editing
                onChange={(e) => updateContent(index, e.target.value)} // handle innerHTML change
                placeholder={t("Tab titel")}
                    />
            </div>
          </div>

        )}
      </div>
      <div className="tabContent">
        { state.items.map((item, index) =>
          <div key={index} className={"item " + (item.visible == true ? 'content_visible':'')}>

            <div className="content">
            <div className="editor_holder">
              <Editor
                inline
                value={item.content2 != '' ? item.content2 : ''}
                init={{
                  base_url: '/tinymce', // Base path for all TinyMCE resources
                  skin_url: '/tinymce/skins/ui/oxide',
                  content_css: '/tinymce/skins/content/default/content.css',
                  menubar:false,
                  plugins: 'link image code lists advlist',
                  toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | fontsizeselect | link | removeformat | code",
                  setup: editor => {
                    //Keep bg image dark if on focus
                    editor.on('keydown', function(e){
                      if(e.target.nextSibling.nextSibling.classList)
                      {

                        if(e.target.nextSibling.nextSibling.classList.contains('placeholder_editor')){
                          e.target.nextSibling.nextSibling.classList.add("hide")
                        }
                      }
                    });


                  }
                  /*myCustomToolbarButton
                  setup: (editor) => {
                    editor.ui.registry.addButton('myCustomToolbarButton', {
                      text: 'My Custom Button',
                      onAction: () => props.showMediaLibrary()
                    });

                  }  */
                }}
                onEditorChange={(content, editor) => updateContent2(index, content)}
                />
                {item.content2 == "" ?
                  <div className="placeholder_editor">
                    {t("Plaats hier uw tekst")}...
                  </div>
                :''}
              </div>
              <br/>
              <AddImage image={item.image} showMediaLibrary={props.showMediaLibrary} index={props.index} deleteImage={deleteImage} />

            </div>
            <div className="accordion_actions">
              {index != 0 ? <div>
                <span className="btn grey swap" onClick={() => swapItem(index, index - 1)} data-tip={t("Tab naar links")}>
                  <i className="fa fa-chevron-left"></i>
                </span>
              </div>:''}
              {index != state.items.length - 1 ? <div>
                <span className="btn grey swap" onClick={() => swapItem(index, index+1)} data-tip={t("Tab naar rechts")}>
                  <i className="fa fa-chevron-right"></i>
                </span>
              </div>:''}
              <div>
                <span className="addd btn grey" onClick={(e) => addItem(index, '')} data-tip={t("Item toevoegen")}><i className="fa fa-plus"></i></span>
              </div>
              <div>
                <span className="delete btn " onClick={(e) => deleteItem(index, e)} data-tip={t("Verwijder tab")}><i className="fa fa-minus"></i></span>
              </div>
            </div>
            <ReactTooltip place="top" effect="solid" delayShow={200}   />
          </div>
        )}

      </div>
    </div>
  );
}

export default Tabs;
